import React from "react"

import ContentLines from "./content-loading/ContentLines"
import ListItemImageShadow from "./content-loading/ListItemImageShadow"

const PlaceholderImageListItemShadow = () => (
    <div className="placeholder-box">
        <ListItemImageShadow />
        <ContentLines
            className="placeholder-caption"
            minLineLength={30}
            maxLineLength={70}
            minLines={1}
            maxLines={3}
        />
    </div>
)

export default PlaceholderImageListItemShadow
